import React from 'react'

const EnergyBoltingBrandInvert = () => (
  <svg className="icon">
    <use
      xlinkHref={`/Static/Images/icons.svg?=${process.env.BUILD_VERSION_ID}#icon--energy-bolting-brand-invert`}
    />
  </svg>
)

export default EnergyBoltingBrandInvert
